import { useQuery } from 'react-query';
import { getFXRatesById } from '~/api/fxrates';

export const useGetFXRatesById = (id: string) => {
  return useQuery(['fxrates', id], () => getFXRatesById(id), { staleTime: Infinity });
};
